import { render } from "./LightFooter.vue?vue&type=template&id=5eed18d3&ts=true"
import script from "./LightFooter.vue?vue&type=script&lang=ts"
export * from "./LightFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__